import Header from "@components/Header";
import { ArrowRightCircleIcon } from "@heroicons/react/16/solid";
import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { useUserData } from "@hooks/auth";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { showToast } from "../../app/store/statusSlice";

function UserProfilePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useUserData();
  const { t } = useTranslation(["userProfilePage"]);

  const handleCopyUserId = () => {
    navigator.clipboard.writeText(user.user?.id ?? "");
    dispatch(
      showToast({
        message: t("userProfilePage.copyUserId", { ns: "toast" }),
        type: "info",
      }),
    );
  };

  return (
    <Header>
      <div className="flex justify-center">
        <div className="max-w-3xl rounded-xl bg-neutral p-8 shadow-xl">
          <div className="flex flex-col items-center gap-10">
            <h1 className="font-bold text-2xl">{t("title")}</h1>
            <p className="">{t("description")} </p>
            <div className="flex flex-col items-center justify-center gap-2 space-x-4 rounded-lg border border-primary p-3 sm:flex-row">
              <span className="font-medium text-sm">{t("userIdLabel")}: </span>
              <span className="font-bold">
                {user.user?.id ?? t("noUserId")}
              </span>
              <button
                type="button"
                onClick={handleCopyUserId}
                className="btn btn-sm btn-outline"
              >
                <DocumentDuplicateIcon className="h-5 w-5" />
                {t("copy")}
              </button>
            </div>
            <p className="">{t("tryOut")}</p>
            <button
              type="button"
              onClick={() => navigate("/")}
              className="btn btn-outline"
            >
              {t("tryOutButton")}
              <ArrowRightCircleIcon className="ml-2 h-6 w-6" />
            </button>
          </div>
        </div>
      </div>
    </Header>
  );
}

export default UserProfilePage;
